import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { v4 as uuid } from 'uuid';
import { flowNodeColor, FlowType } from 'fable/flowEditor';
import { hexStringToNumber } from 'fable/flowEditor/components/flowManager/canvas/renderers/common/colors';
import { Text } from 'flow-builder/node/text';
import { TextContent } from 'flow-builder/node/textContent';
import { TextEllipsis } from 'flow-builder/node/textEllipsis';
import FiltersModal from '../../../containers/modals/filters';
import { SystemVariableType, } from '../../../helpers/flowVariableHelpers';
import { ConditionOutcome, } from '../../types';
const translatePayload = (node) => {
    const { non_match_node_id, match_node_id } = node.payload;
    return [
        {
            id: uuid(),
            type: 'out',
            label: ConditionOutcome.NO_MATCH,
            connection: non_match_node_id || uuid(),
        },
        {
            id: uuid(),
            type: 'out',
            label: ConditionOutcome.MATCH,
            connection: match_node_id || uuid(),
        },
    ];
};
const updateConnection = (node, connection, connectionId) => {
    const entryName = connection.connectionLabel === ConditionOutcome.MATCH
        ? 'match_node_id'
        : 'non_match_node_id';
    const payload = Object.assign(Object.assign({}, node.payload), { [entryName]: connectionId });
    return Object.assign(Object.assign({}, node), { payload });
};
const translateScopeVariables = (node) => {
    const { payload: { rules = [] } = {} } = node;
    const needs = rules.reduce((acc, { variable, match }) => {
        if ((variable === null || variable === void 0 ? void 0 : variable.type) !== SystemVariableType.System && variable.id) {
            acc.push(variable.id);
        }
        const isMatchScopeVariable = (match === null || match === void 0 ? void 0 : match.type) === SystemVariableType.Scope;
        if (match.id && isMatchScopeVariable) {
            acc.push(match.id);
        }
        return acc;
    }, []);
    return {
        needs: [...new Set(needs)],
        grants: [],
    };
};
const createFiltersNode = (flowType) => ({
    iconName: 'branch',
    label: 'Filters',
    color: hexStringToNumber(flowNodeColor.purple),
    helpText: 'Sort conversations based on whether they match your chosen criteria.',
    translateScopeVariables,
    translatePayload,
    updateConnection,
    NodeContent: FiltersNode,
    ActionModal: FiltersModal(flowType),
});
export const FiltersNodePhoneAttributes = createFiltersNode(FlowType.FLOW_TYPE_CALL);
export const FiltersNodeEmailAttributes = createFiltersNode(FlowType.FLOW_TYPE_EMAIL);
export const FiltersNodeMessengerAttributes = createFiltersNode(FlowType.FLOW_TYPE_MESSENGER);
export function FiltersNode({ node }) {
    const { payload } = node;
    const { rules, description } = payload;
    const isDescriptionSet = !!description;
    return (_jsx(TextContent, { children: useMemo(() => (_jsxs(_Fragment, { children: [_jsx(TextEllipsis, { children: _jsx(Text, { weight: "semibold", text: isDescriptionSet ? description : 'Add a description' }) }), _jsx(TextEllipsis, { children: _jsx(Text, { weight: "semibold", text: `${rules.length} ${rules.length === 1 ? 'rule' : 'rules'}` }) })] })), [isDescriptionSet, description, rules.length]) }));
}
